function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 8,
  transform: "rotate(90 8 8)",
  fill: "#323150"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M12 4.5C12 4.22386 11.7761 4 11.5 4C11.2239 4 11 4.22386 11 4.5L11 11.5C11 11.7761 11.2239 12 11.5 12C11.7761 12 12 11.7761 12 11.5L12 4.5Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M10.3536 8.35355C10.5488 8.15829 10.5488 7.84171 10.3536 7.64645L7.17157 4.46447C6.97631 4.2692 6.65973 4.2692 6.46447 4.46447C6.2692 4.65973 6.2692 4.97631 6.46447 5.17157L9.29289 8L6.46447 10.8284C6.2692 11.0237 6.2692 11.3403 6.46447 11.5355C6.65973 11.7308 6.97631 11.7308 7.17157 11.5355L10.3536 8.35355ZM2 8.5L10 8.5L10 7.5L2 7.5L2 8.5Z",
  fill: "white"
});

var SvgSent = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sent.e24acccb.svg";
export { ForwardRef as ReactComponent };